import AuthService from '../services/auth.service';
import user_class from "@/class/user_class"


const user = JSON.parse(localStorage.getItem('user'));

const initialState = user
  ? { status: { loggedIn: true }, user , users : [], permissions : null}
  : { status: { loggedIn: false }, user: null, users : null, permissions : null };
let userClass = new user_class(user);
export const auth = {
  namespaced  : true,
  state       : initialState,
  actions     : {
    login({ commit, dispatch }, user) {
      return AuthService.login(user).then(
        async user => {
          commit('loginSuccess', user)
          // Cargar permisos automáticamente después del login exitoso
          try {
            await dispatch('list_permissions');
            
          } catch (error) {
            
          }
         
          return Promise.resolve(user);
        },
        error => {
          
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
         
          return Promise.resolve(response)//.data
        }).catch( //,
        error => {
          commit('registerFailure');
          return Promise.reject(error);
          
        }
      );
    },
    recover_psw( { commit }) {
      return AuthService.recover_psw(user).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return Promise.reject(error)
        }
      )//then
    },
    list_permissions({commit, state}){
      let temp = state && state.user && state.user.user ? state.user.user : null;
      
      
      userClass.render_permissions_user();                
      commit("set_permissions", userClass.get_item("permission"))
      
      return AuthService.list_permissions(temp).then( resp =>{
        
        
        if (resp && resp.data && resp.data.rows &&  resp.data.rows.length > 0) {
          
          userClass.update_item("list_permissions_user", resp.data.rows);          
          userClass.render_permissions_user();
          commit("set_permissions", userClass.get_item("permission"))
          
          return Promise.resolve(userClass.get_item("permission"));
        } else {
          
          
          return Promise.resolve(userClass.get_item("permission"));
        }

      }).catch(err => {
        
        return Promise.reject(null);
      });
    },
    list_resources({commit}){
      return AuthService.list_resources().then( resp =>{
        if (resp && resp.data && resp.data.rows &&  resp.data.rows.length > 0) {
          userClass.update_item("list_resources", resp.data.rows);
        }
        Promise.resolve(true);
      }).catch(er => { Promise.reject(null)});
    },

    check_permission({ commit }, action) {
      return userClass.check_permissions(action);
    },

    list_users({commit}){
      return AuthService.list_users('all').then(resp =>{
        if (resp && resp.data && resp.data.rows && resp.data.rows.length > 0){
          commit('list_users', resp.data.rows);
          
          return  Promise.resolve(resp.data.rows);

        }else{
          return Promise.resolve(null);
        }
      })
    },
    diff_resources({ commit }, item){
      let temp_resources  = item.resources; // list bd
      let temp            = userClass.get_item("list_default_resources")
      let list_resources  = []; // new list default
      let result          = [];
      if (temp && temp.length > 0) {
        list_resources = [ ...temp ];
      }
      if (list_resources && list_resources.length > 0) {

        if (temp_resources && temp_resources.length > 0) {
          return result = list_resources.filter(x => {
            if (x && x.module) {
              let idx = temp_resources.findIndex(z => (z && z.name.includes(x.module)));
              if (idx < 0) {
                return x;
              }
            }

          })
        }else{
         
        }
      }else{
        
      }
      return [];
    }, // diff_resources

    diff_permissions({commit}, item){
      let temp_permissions  = item.permissions; // db
      let list_resources    = userClass.get_item("list_resources");
      
      if (temp_permissions && temp_permissions.length > 0) {
        
          return userClass.diff_permissions(temp_permissions, list_resources);
        
      }else{
        if (list_resources && list_resources.length > 0) {          
          return list_resources;
        }
      }
      return []
    }, // diff_permissions
  },
  getters   : {
    user : (state)=> {
      
        return state.user;
      },
    list_default_permissions : (state) =>{
      return userClass.get_item("list_default_permissions");
    },

    list_default_resources : () =>{
      return userClass.get_item("list_default_resources");
    }, 
    permissions(state){      // no in use
      
      state.permissions =  userClass.get_item("permission");
      return state.permissions;
    },

    permission : (state) =>{ // check_
      return (modul, action, modul1)=> {

        if (!modul) {
         
        }
        if (!state.permissions) {
          
        }          
        if (state && state.user && state.user.user && state.user.user.roleId && state.user.user.roleId == 1) {    
          if (action) {
            return true;
          }     
          return {
            can_add       : true,
            can_edit      : true,
            can_view      : true,
            can_delete    : true,
            name          : modul || modul1,
          }
        }
        
        if (state && state.permissions && state.permissions[modul] && state.permissions[modul][action]) {
            // action : can_add, can_view, can_edit , can_delete      
          return true;
          
        }else if(state && state.permissions && !state.permissions[modul] && state.permissions[modul1]  && state.permissions[modul1][action]){
          return true;          
        }
        else{
          if (!action && state && state.permissions && (state.permissions[modul] || state.permissions[modul1] )) { // for return object
            return state.permissions[modul] || state.permissions[modul1];
          }
          return false
        }
      } 
      
    },


  }, // gettters
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    list_users(state, list){
      state.users = list;
    },
    set_permissions(state, item){
      state.permissions = item;
    },
    update_permission(state, item){
      if (item && state && state.permissions && item.name && item.roleId == state.permissions[item.name].roleId) {        
        state.permissions[item.name] = { ...item };
        userClass.update_item("permission", {...state.permissions});
      }
    },

    create_permission(state, item){
      if (item && state && state.permissions && item.name && item.roleId == state.user.roleId) {        
        state.permissions[item.name] = { ...item };
        userClass.update_item("permission", {...state.permissions});
      }
    },   
    delete_permission(state, item){
       if (item && state && state.permissions && item.name && item.roleId == state.user.roleId) {        
        delete state.permissions[item.name];
        userClass.update_item("permission", {...state.permissions});
      }
    }

  }
};